import React from 'react';
import { DrawerField } from '@paretogroup/tess';
import { initialsName } from '@domain/segments/segments-drawer/segments.utils';
import TEST_ID from '@shared/constants/testId.constants';
import { createColorFromName } from '@shared/utils/colors';
import { StartIcon } from './option-with-edit-delete-icon.styles';

const defaultProps = {
    onClick: () => {},
    value: null,
    checked: false,
    isEditable: true,
    isDeletable: true,
};

interface OptionWithEditDeleteIconProps {
    label: string;
    onClick?: (e: any) => void;
    onDelete: (e: any) => void;
    onEdit: (e: any) => void;
    value?: String | Number;
    checked?: Boolean;
    isEditable?: Boolean;
    isDeletable?: Boolean;
}

export const OptionWithEditDeleteIcon = ({
    label,
    onClick,
    onDelete,
    onEdit,
    value,
    isEditable,
    isDeletable,
}: OptionWithEditDeleteIconProps) => {
    const handleOnEdit = (event) => {
        onEdit(value);
        event.stopPropagation();
    };

    const handleOnDelete = (event) => {
        onDelete(value);
        event.stopPropagation();
    };

    return (
        <DrawerField
            data-testid={TEST_ID.MULTI_SELECTOR.OPTION_WITH_EDIT_AND_DELETE}
            onClick={() => onClick(value)}
            label={label}
            onEditOnClick={isEditable ? handleOnEdit : null}
            onDeleteOnClick={isDeletable ? handleOnDelete : null}
            startIcon={(
                <StartIcon
                    backgroundColor={createColorFromName(label)}
                >
                    {initialsName(label)}
                </StartIcon>
            )}
        />
    );
};

OptionWithEditDeleteIcon.defaultProps = defaultProps;
